import React from 'react';
import { contactData } from '../data/mock';

const ImpressumPage = () => {
  return (
    <div style={{ background: '#000000', position: 'relative' }}>
      <div className="pattern-overlay" />
      
      <section style={{ paddingTop: '140px', paddingBottom: '80px', position: 'relative' }}>
        <div className="container mx-auto px-4" style={{ maxWidth: '900px' }}>
          <h1 className="display-large" style={{ 
            marginBottom: '60px',
            animation: 'fade-in-up 0.8s ease-out'
          }}>
            Impressum
          </h1>

          <div className="glass-card" style={{
            padding: '40px',
            animation: 'fade-in-up 0.8s ease-out 0.2s both'
          }}>
            <div style={{ lineHeight: '1.8' }}>
              <h2 className="heading-1" style={{ marginBottom: '20px', color: '#00A8CC' }}>
                Angaben gemäß § 5 TMG
              </h2>
              
              <div style={{ marginBottom: '32px' }}>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '8px' }}>
                  <strong>Crash Check</strong>
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Einzelunternehmen
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Inhaber: {contactData.owner}
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#00A8CC' }}>
                  Kontakt
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '8px' }}>
                  <strong>Telefon:</strong> {contactData.phone}
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '8px' }}>
                  <strong>E-Mail:</strong> {contactData.email}
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#00A8CC' }}>
                  Social Media und Online-Präsenzen
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '8px' }}>
                  <strong>Instagram:</strong>{' '}
                  <a 
                    href={contactData.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#00A8CC', textDecoration: 'none' }}
                  >
                    @crash_check24
                  </a>
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  <strong>WhatsApp:</strong> {contactData.phone}
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#00A8CC' }}>
                  Hinweis gemäß § 5 TMG
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Crash Check ist nicht im Handelsregister eingetragen.
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#00A8CC' }}>
                  Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  {contactData.owner}
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#00A8CC' }}>
                  Haftungsausschluss
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  <strong>Haftung für Inhalte:</strong><br/>
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  <strong>Haftung für Links:</strong><br/>
                  Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '16px', color: '#00A8CC' }}>
                  Urheberrecht
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;